import { useEffect } from 'react';

// Public pages share one index.html, so each sets its own title, description
// and canonical address while mounted, then puts back what was there. The
// canonical address names the page's main URL, so /utm/... and /webapp count
// as the homepage. Signed-in pages stay out of search with NoIndexMetadata.
//
// www.routora.com is the canonical host already used by the app-install QR
// code and billing return URLs; Stage 6 confirms the apex domain redirects.
export const CANONICAL_ORIGIN = 'https://www.routora.com';

function setHeadElement(selector, create, attribute, value) {
  let element = document.head.querySelector(selector);
  const created = !element;
  const previous = element?.getAttribute(attribute) ?? null;

  if (!element) {
    element = create();
    document.head.appendChild(element);
  }
  element.setAttribute(attribute, value);

  return () => {
    if (created) element.remove();
    else if (previous === null) element.removeAttribute(attribute);
    else element.setAttribute(attribute, previous);
  };
}

function meta(name) {
  return () => {
    const element = document.createElement('meta');
    element.setAttribute('name', name);
    return element;
  };
}

function canonicalLink() {
  const element = document.createElement('link');
  element.setAttribute('rel', 'canonical');
  return element;
}

export default function usePageMetadata({ title, description, path }) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    const restore = [
      setHeadElement('meta[name="description"]', meta('description'), 'content', description),
      setHeadElement('link[rel="canonical"]', canonicalLink, 'href', `${CANONICAL_ORIGIN}${path}`),
    ];

    return () => {
      document.title = previousTitle;
      restore.forEach((undo) => undo());
    };
  }, [title, description, path]);
}
